var map = {
	"./a.m4a": 25050,
	"./ba.m4a": 13378,
	"./be.m4a": 34878,
	"./bi.m4a": 9418,
	"./bo.m4a": 76468,
	"./bu.m4a": 14926,
	"./bya.m4a": 52655,
	"./byo.m4a": 56825,
	"./byu.m4a": 20059,
	"./cha.m4a": 37629,
	"./chi.m4a": 7877,
	"./cho.m4a": 35067,
	"./chu.m4a": 71833,
	"./correct.MP3": 28551,
	"./countdown.MP3": 66704,
	"./da.m4a": 93292,
	"./de.m4a": 57744,
	"./di.m4a": 76884,
	"./do.m4a": 85706,
	"./du.m4a": 97024,
	"./dya.m4a": 58021,
	"./dyo.m4a": 7059,
	"./dyu.m4a": 98849,
	"./e.m4a": 6646,
	"./enter.MP3": 54819,
	"./fu.m4a": 78778,
	"./ga.m4a": 98725,
	"./ge.m4a": 67665,
	"./gi.m4a": 75453,
	"./go.m4a": 71059,
	"./goodjob_eng.m4a": 87326,
	"./goodjob_jp.m4a": 8948,
	"./goodjob_zh.m4a": 76236,
	"./gu.m4a": 70177,
	"./gya.m4a": 13242,
	"./gyo.m4a": 32348,
	"./gyu.m4a": 46534,
	"./ha.m4a": 61136,
	"./he.m4a": 66060,
	"./hi.m4a": 46328,
	"./hiraganaquiz_bgm.MP3": 10554,
	"./ho.m4a": 23462,
	"./hook.MP3": 75254,
	"./hya.m4a": 54657,
	"./hyo.m4a": 9543,
	"./hyu.m4a": 83205,
	"./i.m4a": 44946,
	"./ja.m4a": 8202,
	"./japanese 46 sounds.m4a": 74842,
	"./ji.m4a": 57250,
	"./jo.m4a": 61868,
	"./ju.m4a": 58550,
	"./ka.m4a": 4489,
	"./ke.m4a": 23101,
	"./ki.m4a": 51953,
	"./ko.m4a": 51436,
	"./ku.m4a": 14093,
	"./kya.m4a": 10166,
	"./kyo.m4a": 64192,
	"./kyu.m4a": 59818,
	"./ma.m4a": 64763,
	"./me.m4a": 7903,
	"./mi.m4a": 86611,
	"./mo.m4a": 89706,
	"./mu.m4a": 81007,
	"./mya.m4a": 44772,
	"./myo.m4a": 10418,
	"./myu.m4a": 39352,
	"./n.m4a": 13193,
	"./na.m4a": 37134,
	"./ne.m4a": 62226,
	"./ni.m4a": 23926,
	"./no.m4a": 17640,
	"./nu.m4a": 92002,
	"./nya.m4a": 83139,
	"./nyo.m4a": 10805,
	"./nyu.m4a": 35991,
	"./o.m4a": 44156,
	"./pa.m4a": 58904,
	"./pe.m4a": 53460,
	"./pi.m4a": 34320,
	"./po.m4a": 59454,
	"./pu.m4a": 93060,
	"./pya.m4a": 68137,
	"./pyo.m4a": 92703,
	"./pyu.m4a": 54445,
	"./quizresult_bgm.MP3": 15460,
	"./ra.m4a": 74642,
	"./re.m4a": 56878,
	"./ri.m4a": 55354,
	"./ro.m4a": 92644,
	"./ru.m4a": 53150,
	"./rya.m4a": 83487,
	"./ryo.m4a": 88265,
	"./ryu.m4a": 14315,
	"./sa.m4a": 44241,
	"./se.m4a": 75301,
	"./sha.m4a": 63277,
	"./shi.m4a": 46165,
	"./sho.m4a": 38251,
	"./shu.m4a": 28553,
	"./so.m4a": 25911,
	"./stop.MP3": 75315,
	"./su.m4a": 725,
	"./sweep.MP3": 1437,
	"./ta.m4a": 53308,
	"./tap.MP3": 51534,
	"./te.m4a": 69824,
	"./test.m4a": 32629,
	"./to.m4a": 34202,
	"./tsu.m4a": 88799,
	"./typing game1.MP3": 74349,
	"./typing_bgm.MP3": 43317,
	"./u.m4a": 58342,
	"./u.mp3": 17592,
	"./vocabulary_bgm.MP3": 33352,
	"./wa.m4a": 66741,
	"./wo.m4a": 87491,
	"./wrong.MP3": 58706,
	"./ya.m4a": 68743,
	"./yo.m4a": 60833,
	"./yu.m4a": 10131,
	"./za.m4a": 11578,
	"./ze.m4a": 502,
	"./zo.m4a": 7388,
	"./zu.m4a": 44870
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 64330;